import {commonActions} from '../../actions/commonActions';
import {cityGetList, stateSetItem} from '../../actions/areaActions';
import {connect} from 'react-redux';
import List from '../../components/area/CityList';
import {API_FETCH} from '../../services/FetchService';
import {getItem} from './AddEditStateFormPage';
import {list as areaList} from '../../containers/area/AreaListPage';
import {commonConstants} from "../../constants";



const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getList: (value) => {
        dispatch(list(value));
    },
    getStateItem: (id) => {
        dispatch(stateItem(id));
    },
    getAreaList : () => {
        return(dispatch(areaList()));
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Search Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(list(value));
    },

});

export const list = (value) => {
    return (dispatch, getState) => {
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.get('area/city',{params: value}).then(list => {
            if(list.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
            }
            dispatch(cityGetList(list.data));
        }).catch(error => {
            console.log(error);
        });
    }

}

const stateItem = (id) => {
    getItem(id)
}


const mapStateToProps = state => {
    return {
        userValue    : state.app.currentUser,
        list         : state.area.cityList,
        common       : state.common,
        initialValues: state.area.stateTargetItem,
        areaList     : state.area.areaList,
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(List);
